
import { OreList, OreListItem, OreText } from '@edenredespana/oreneta';
import { ProfileType, ProfileOption, MerchantType } from './ProfileTypes';
import { accessRolesTranslation } from '@/AccessRoles/ui/AccesRolesTranslation';
import { t } from 'i18next';

type RoleKey = 'Visor' | 'Admin' | 'SuperAdmin';

function getRoleTexts(role: RoleKey, merchantType: MerchantType, isNursery: boolean) {
  const texts: { key: string; jsx: React.ReactNode }[] = [];


  // Descargas
  let downloads: string;
  if (merchantType === 1 || merchantType === 4) downloads = t(accessRolesTranslation.modal.roleA.downloads);
  else if (merchantType === 3) downloads = t(accessRolesTranslation.modal.roleI.downloads);
  else if (merchantType === 5 && isNursery) downloads = t(accessRolesTranslation.modal.roleB.downloads);
  else downloads = t(accessRolesTranslation.modal.roleB.downloads);
  texts.push({ key: 'downloads', jsx: <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>{downloads}</OreText> });

  // TPVs
  if (!isNursery) {
    texts.push({ key: 'tpvs', jsx: <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>{t(accessRolesTranslation.modal.roleA.tpvs)}</OreText> });
  }

  // Búsqueda y contratos
  if (role === 'Visor' && isNursery) {
    const visorText = (merchantType === 5) 
    ? t(accessRolesTranslation.modal.roleGuarderia.searchC)
    : t(accessRolesTranslation.modal.roleGuarderia.searchA);
    texts.push({ key: 'searchVisor', jsx: <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
      {visorText}</OreText> });
  }
  if (role === 'Visor' && !isNursery) {
    const visorText = (merchantType === 1 || merchantType === 3 || merchantType === 4)
      ? t(accessRolesTranslation.modal.roleA.searchVisor)
      : t(accessRolesTranslation.modal.roleB.searchVisor);
    texts.push({ key: 'searchVisor', jsx: <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>{visorText}</OreText> });
  }
  if (role === 'Admin' && isNursery) {
     texts.push({
      key: 'searchAdmin',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          {merchantType === 5 ? (<>{t(accessRolesTranslation.modal.roleGuarderia.searchB)} 
          <b>{t(accessRolesTranslation.modal.roleA.search2)}</b>
          {t(accessRolesTranslation.modal.roleGuarderia.searchD)}</>) : 
          (<>{t(accessRolesTranslation.modal.roleGuarderia.searchB)} 
          <b>{t(accessRolesTranslation.modal.roleA.search2)}</b>
          {t(accessRolesTranslation.modal.roleGuarderia.searchB2)}</>)}
        </OreText>
      )
    });
    if(merchantType !== 5) {
      texts.push({
          key: 'contract',
          jsx: (
            <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
              <b>{t(accessRolesTranslation.modal.roleGuarderia.edit)}</b>
            </OreText>
          )
      });
    }
  }
  if (role === 'Admin' && !isNursery) {
    texts.push({
      key: 'searchAdmin',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          {t(accessRolesTranslation.modal.roleA.search1)} <b>{t(accessRolesTranslation.modal.roleA.search2)}</b> {(merchantType === 1 || merchantType === 3 || merchantType === 4)
            ? t(accessRolesTranslation.modal.roleA.search3)
            : t(accessRolesTranslation.modal.roleB.search3)}
        </OreText>
      )
    });
    if (merchantType === 3) {
      texts.push({
        key: 'contract',
        jsx: (
          <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
            <b>{t(accessRolesTranslation.modal.roleB.contract1)}</b> {t(accessRolesTranslation.modal.roleB.contract2)}
          </OreText>
        )
      });
    }
  }
  if (role === 'SuperAdmin' && isNursery) {
    texts.push({
      key: 'searchSuperAdmin',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          {merchantType === 5 ? (<>{t(accessRolesTranslation.modal.roleGuarderia.searchB)} 
          {t(accessRolesTranslation.modal.roleA.search2)}
          {t(accessRolesTranslation.modal.roleGuarderia.searchD)}</>) : 
          (<>{t(accessRolesTranslation.modal.roleGuarderia.searchB)} 
          {t(accessRolesTranslation.modal.roleA.search2)}
          {t(accessRolesTranslation.modal.roleGuarderia.searchB2)}</>)}
        </OreText>
      )
    });
    if(merchantType !== 5) {
      texts.push({
          key: 'contractSuper',
          jsx: (
            <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
              {t(accessRolesTranslation.modal.roleGuarderia.edit)}
            </OreText>
          )
      });
    }
    texts.push({
      key: 'createSuper',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          <b>{t(accessRolesTranslation.modal.roleA.create)}</b>
        </OreText>
      )
    });
  }
  if (role === 'SuperAdmin' && !isNursery) {
    texts.push({
      key: 'searchSuperAdmin',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          {t(accessRolesTranslation.modal.roleA.search1)} {merchantType === 3
            ? t(accessRolesTranslation.modal.roleA.search2)
            : <b>{t(accessRolesTranslation.modal.roleA.search2)}</b>} {(merchantType === 1 || merchantType === 3 || merchantType === 4)
            ? t(accessRolesTranslation.modal.roleA.search3)
            : t(accessRolesTranslation.modal.roleB.search3)}
        </OreText>
      )
    });
    if (merchantType === 3) {
      texts.push({
        key: 'contractSuper',
        jsx: (
          <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
            {t(accessRolesTranslation.modal.roleB.contract1)} {t(accessRolesTranslation.modal.roleB.contract2)}
          </OreText>
        )
      });
    }
    texts.push({
      key: 'createSuper',
      jsx: (
        <OreText tone="neutral-600" size="text-xs" style={{ fontSize: '14px', fontWeight: 400 }}>
          <b>{t(accessRolesTranslation.modal.roleA.create)}</b>
        </OreText>
      )
    });
  }
  return texts;
}

function createRoleDescription(role: RoleKey, merchantType: MerchantType, isNursery: boolean) {
  const items = getRoleTexts(role, merchantType, isNursery);
  return (
    <OreList bullet>
      {items.map(item => (
        <OreListItem key={item.key}>{item.jsx}</OreListItem>
      ))}
    </OreList>
  );
}

export const getProfileOptions = (merchantType: MerchantType, isNursery: boolean): ProfileOption[] => [
  {
    value: 'Visor' as ProfileType,
    label: 'Visor',
    description: createRoleDescription('Visor', merchantType, isNursery),
  },
  {
    value: 'Admin' as ProfileType,
    label: 'Administrador',
    description: createRoleDescription('Admin', merchantType, isNursery),
  },
  {
    value: 'SuperAdmin' as ProfileType,
    label: 'Super Admin',
    description: createRoleDescription('SuperAdmin', merchantType, isNursery),
  },
];